// extracted by mini-css-extract-plugin
module.exports = {"tablet":"1023.98px","sectionBackground":"Manifesto-module--sectionBackground--3tdTu"};